/**
 * @generated SignedSource<<8cad99a3a632dd6b0851f39ac0e82aba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedVideoComponent_componentModule$data = {
  readonly userType: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedVideoComponentCarousel_componentModule" | "HpSharedVideoComponentTitle_componentModule" | "HpSharedVideoComponentVideo_componentModule">;
  readonly " $fragmentType": "HpSharedVideoComponent_componentModule";
};
export type HpSharedVideoComponent_componentModule$key = {
  readonly " $data"?: HpSharedVideoComponent_componentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedVideoComponent_componentModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedVideoComponent_componentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userType",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedVideoComponentTitle_componentModule"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedVideoComponentVideo_componentModule"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedVideoComponentCarousel_componentModule"
    }
  ],
  "type": "VideoModule",
  "abstractKey": null
};

(node as any).hash = "33f17b1028960b3a3df5f5d3466493ce";

export default node;
